import { AiPendingActionsGridView } from '~/components/system/ai-pending-actions';
import { PageContainer } from '~/components/page-container';

export function AiPendingActions() {
	return (
		<PageContainer>
			<AiPendingActionsGridView />
		</PageContainer>
	);
}
